import {
  createContext,
  useContext,
  ReactNode,
  useState,
  useCallback,
  useMemo,
} from 'react';

type DashboardLayoutContextType = {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
};

const SidebarContext = createContext<DashboardLayoutContextType>({} as DashboardLayoutContextType);

export function useDashboardLayout() {
  return useContext(SidebarContext);
}

interface DashboardLayoutProviderProps {
  children?: ReactNode;
}

export const DashboardLayoutProvider = ({ children = undefined }: DashboardLayoutProviderProps) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = useCallback(() => {
    setSidebarToggle((prev) => !prev);
  }, []);
  const closeSidebar = useCallback(() => {
    setSidebarToggle(false);
  }, []);
  const contextValue = useMemo(() => ({
    sidebarToggle,
    toggleSidebar,
    closeSidebar,
  }), [sidebarToggle, toggleSidebar, closeSidebar]);

  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
};
